import { render, staticRenderFns } from "./SGKExitApprovalLevelCreate.vue?vue&type=template&id=9cfd9464&"
import script from "./SGKExitApprovalLevelCreate.vue?vue&type=script&lang=js&"
export * from "./SGKExitApprovalLevelCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports